import React, { ReactNode } from "react";
import cn from "classnames";
import styles from "./title.module.scss";

interface TitlePropTypes {
  text: string | ReactNode;
  tag?: keyof JSX.IntrinsicElements;
  variant?: string | string[];
}

export const Title = ({ text, tag = "h1", variant }: TitlePropTypes) => {
  let variantClass = "";

  if (typeof variant === "string") {
    variantClass = styles[`title--${variant}`];
  } else if (Array.isArray(variant)) {
    variantClass = variant.map((v) => styles[`title--${v}`]).join(" ");
  }

  return React.createElement(
    tag,
    { className: cn(styles.title, variantClass) },
    text,
  );
};
